<template>
  <DetailsFlow :overview="activeTab" :detail="detailName" />
  <SubscriptionDetails v-if="!showSubscription" />
  <el-tabs
    v-model="activeTab"
    type="card"
    v-if="showProducts && showSubscription"
  >
    <el-tab-pane label="Licensed Products" name="Products" disabled>
      <ProductsList />
    </el-tab-pane>
    <el-tab-pane label="Credential-based Products" name="Credential-based">
      <SubscriptionsList v-if="showSubscription" />
    </el-tab-pane>
  </el-tabs>
</template>
<style lang="scss">
.el-tabs__item.is-disabled {
  border-bottom: 1px solid #efefef !important;
  background: #d6d8da;
  color: #bfbfbf !important;
}
.el-tabs--card > .el-tabs__header {
  border-bottom: unset;
  height: 50px !important;
}
</style>

<script lang="ts">
import { defineComponent } from "vue";
import DetailsFlow from "@/components/DetailsFlow.vue";
import ProductsList from "@/components/ProductsList.vue";
import SubscriptionsList from "@/components/SubscriptionsList.vue";
import SubscriptionDetails from "@/components/SubscriptionDetails.vue";
import { mapGetters } from "vuex";
import _ from "lodash";

export default defineComponent({
  name: "ProductsView",
  components: {
    DetailsFlow,
    ProductsList,
    SubscriptionsList,
    SubscriptionDetails,
  },
  data() {
    return {
      activeTab: "Credential-based",
    };
  },
  computed: {
    ...mapGetters(["getProductData", "getSubscriptionData", "getCurrentUser"]),
    showProducts(): any {
      return _.isEmpty(this.getProductData);
    },
    showSubscription(): any {
      return _.isEmpty(this.getSubscriptionData);
    },
    currentUser(): any {
      return _.isEmpty(this.getCurrentUser);
    },
    detailName(): string {
      return !_.isEmpty(this.getProductData) ? "Product" : "Credential-based";
    },
  },
});
</script>
